export default __webpack_public_path__ + "static/media/pic1.ce2295cc.jpg";